import { Button, ButtonGroup, Form } from '@mairistem/composants';
import React from 'react';
import DECISION from '../../constants/common/decision';
import type CreditFilterBar from '../../interfaces/common/CreditFilterBar';
import './FilterBar.css';

interface FilterBarProps {
	filters: CreditFilterBar;
	onFilterChange: (filters: CreditFilterBar) => void;
}

const FilterBar = ({ filters, onFilterChange }: FilterBarProps) => {
	const handleTypeClick = (type: number) => {
		if (filters.decision === type) {
			return;
		}

		onFilterChange({ decision: type });
	};

	const handleAnneeExerciceChange = ({
		target: { value },
	}: React.ChangeEvent<HTMLInputElement>) => {
		if (value.length !== 4) {
			return;
		}

		onFilterChange({ exercice: value });
	};

	return (
		<div className="credit-paiement-filter-bar">
			<ButtonGroup className="filter-type">
				<Button
					active={filters.decision === null}
					onClick={() => handleTypeClick(null)}
				>
					AP+AE
				</Button>
				<Button
					active={filters.decision === DECISION.AP}
					onClick={() => handleTypeClick(DECISION.AP)}
				>
					AP
				</Button>
				<Button
					active={filters.decision === DECISION.AE}
					onClick={() => handleTypeClick(DECISION.AE)}
				>
					AE
				</Button>
			</ButtonGroup>
			<Form>
				<Form.Input
					defaultValue={filters.exercice}
					onChange={handleAnneeExerciceChange}
					placeholder="Exercice"
					type="number"
				/>
			</Form>
		</div>
	);
};

export default FilterBar;
